import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, Subject, throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { map, switchMap, catchError } from 'rxjs/operators';
import { SalesService } from "../../../services/sales/sales.service";


@Component({
  selector: 'app-transaction-detail',
  templateUrl: './transaction-detail.component.html',
  styleUrls: ['./transaction-detail.component.scss']
})
export class TransactionsDetailsComponent implements OnInit, OnDestroy {

  private subs: Array<Subscription> = [];
  public transaction: any;
  public isCollapsed = true;
  public isCollapsedTran = true;
  public card: any;
  public cardNumber: string;
  public exchange: any;

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject()

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private salesService: SalesService,
  ) {
  }


  ngOnInit() {
    this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10,
        language: {
          emptyTable: '',
          zeroRecords: 'No hay coincidencias',
          lengthMenu: 'Mostrar _MENU_ elementos',
          search: 'Buscar:',
          info: 'De _START_ a _END_ de _TOTAL_ elementos',
          infoEmpty: 'De 0 a 0 de 0 elementos',
          infoFiltered: '(filtrados de _MAX_ elementos totales)',
          paginate: {
            first: 'Prim.',
            last: 'Últ.',
            next: 'Sig.',
            previous: 'Ant.'
          },
        },
    };

    this.subs.push(
        this.activatedRoute.paramMap.pipe(
          map(params => params.get('id')),
          switchMap(id => this.salesService.getPayment(id)),
          catchError(error => {
            this.router.navigate(['/sales/transactions']);
            return throwError(error);
          })
        ).subscribe(transaction => {
          this.transaction = transaction;
          // console.log(this.transaction);
          this.card = JSON.parse(this.transaction.card);
          this.cardNumber = this.card.card_number.substr(-4,4);
          this.exchange = JSON.parse(this.transaction.exchange_rate);
          this.dtTrigger.next();
        })
      );
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub: Subscription) => sub.unsubscribe());
  }

  onSubmit() {
  }

}
